// Shared Oracle configuration constants

import { OracleAgentChatInput } from '../../graphql-types'
import { PERSONALITY_SAGE_ID } from './personalityFilter'

// Maps invitation feature keys to backend chat channel identifiers
export const FEATURE_TO_CHANNEL: Record<string, string> = {
  oracleCard: 'oracle_cards',
  tarot: 'tarot',
}

// Communication mode constants
export const CHAT_MODE = {
  TEXT: 'text',
  VOICE: 'voice',
} as const

// Default subscription configuration used by both OracleResponsiveLayout and OracleVoiceChat
export const DEFAULT_ORACLE_SUBSCRIPTION_CONFIG = {
  longTermMemory: 'No memories available',
  modelName: 'gpt-4o',
  maxContextDocs: 5,
  maxIterations: 5,
  mode: CHAT_MODE.TEXT,
} as const

export const DEFAULT_TALKING_THRESHOLD = 30
export const DEFAULT_MOBILE_TALKING_THRESHOLD = 50

// Voice configuration constants
export const VOICE_CONFIG = {
  fullDuplex: true,
  silenceThreshold: 3000,
  startedTalkingThreshold: DEFAULT_TALKING_THRESHOLD,
} as const

// Returns the invitation action XML tag for a given feature
const FEATURE_TO_ACTION: Record<string, string> = {
  oracleCard: '<Gaia action="oracle_begin" />',
  tarot: '<Gaia action="tarot_begin" />',
}

export const getInvitationAction = (feature: string): string => FEATURE_TO_ACTION[feature] || ''

// All divination features use Gaia Sage personality
// TODO: add 'horoscope' when that feature is implemented
const SAGE_FEATURES = new Set(['oracleCard', 'tarot'])

export const getInvitationPersonalityId = (feature: string, defaultId: string): string => {
  if (SAGE_FEATURES.has(feature)) return String(PERSONALITY_SAGE_ID)
  return defaultId
}

// Helper function to create subscription input
export const createOracleSubscriptionInput = (
  message: string,
  personalityId: number,
  chatSessionId: string | null,
  mode: typeof CHAT_MODE[keyof typeof CHAT_MODE] = CHAT_MODE.TEXT,
  deepLinks: boolean,
  timezone?: string,
  language?: string,
  chatChannel?: string,
): OracleAgentChatInput => ({
  personalityId: personalityId.toString(),
  message,
  chatSessionId,
  deepLinks,
  timezone,
  language,
  ...DEFAULT_ORACLE_SUBSCRIPTION_CONFIG,
  mode,
  ...(chatChannel && { chatChannel }),
})
